export default __webpack_public_path__ + "static/media/girl-eating.d682e1fe.png";